<template>
  <guest-layout>

    <template #content>
      <div class="row">
        <div class="container">
        <div class="row d-flex justify-content-center">
          <div class="col-md-3 ">
            <img width="190" class="img-fluid mx-auto d-block m-0" src="/assets/img/logos/logo_horizontal.png">
          </div>
        </div>

      <h5 class="font-weight-bolder text-white mt-0">
        Cadastro de Lojista - {{ prefeitura.descricao}}
      </h5>
      </div>
      </div>
      <div class="row">
        <form @submit.prevent="register">
          <div class="col-12">
            <div class="card">
              <div class="card-header pb-0"></div>
              <div class="card-body">
                <div class="container">
                  <p class="text-uppercase text-sm">Informações Pessoais</p>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Nome Completo</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          v-model="form.name"
                          placeholder="Digite o nome completo"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.name }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.name }"
                      >
                        {{ form.errors.name }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Telefone</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          v-model="form.telefone"
                          v-maska="['(##) ####-####', '(##) #####-####']"
                          placeholder="Digite o telefone"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.telefone }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.telefone }"
                      >
                        {{ form.errors.telefone }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >E-mail</label
                        >
                        <input
                          class="form-control"
                          type="email"
                          placeholder="Digite o e-mail"
                          v-model="form.email"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.email }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.email }"
                      >
                        {{ form.errors.email }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Senha</label
                        >
                        <input
                          class="form-control"
                          type="password"
                          placeholder="Digite a senha"
                          v-model="form.password"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.password }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.password }"
                      >
                        {{ form.errors.password }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Confirmar Senha</label
                        >
                        <input
                          class="form-control"
                          type="password"
                          placeholder="Digite a senha novamente"
                          v-model="form.password_confirmation"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.password }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.password }"
                      >
                        {{ form.errors.password }}
                      </div>
                    </div>
                  </div>

                  <hr />

                  <p class="text-uppercase text-sm">Informações da Empresa</p>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >CNPJ</label
                        >
                        <input
                          class="form-control"
                          v-maska="'##.###.###/####-##'"
                          type="text"
                          placeholder="Digite o CNPJ"
                          v-model="form.cnpj"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.cnpj }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.cnpj }"
                      >
                        {{ form.errors.cnpj }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Razão Social</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite a razão social"
                          v-model="form.razao_social"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{
                            'is-invalid': form.errors.razao_social,
                          }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.razao_social }"
                      >
                        {{ form.errors.razao_social }}
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Data de Abertura</label
                        >
                        <input
                          class="form-control"
                          type="date"
                          placeholder="Digite a estado"
                          v-model="form.data_abertura"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.data_abertura }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.data_abertura }"
                      >
                        {{ form.errors.data_abertura }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >CNAE Principal</label
                        >

                        <multiselect
                          v-model="form.cnae_id"
                          placeholder="Selecione o CNAE"
                          :multiple="false"
                          label="descricao"
                          :searchable="true"
                          :options="cnaesOptionConcat"
                          :taggable="false"
                          track-by="id"
                        >
                        </multiselect>
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.cnae_id }"
                      >
                        {{ form.errors.cnae_id }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Porte</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite o Porte"
                          v-model="form.porte"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{
                            'is-invalid': form.errors.porte,
                          }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.porte }"
                      >
                        {{ form.errors.porte }}
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Situação</label
                        >
                        <select class="form-control" v-model="form.situacao">
                          <option value="Ativa">Ativa</option>
                          <option value="Baixada">Baixada</option>
                          <option value="Suspensa">Suspensa</option>
                          <option value="Inapta">Inapta</option>
                        </select>
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{
                          'd-block': form.errors.situacao,
                        }"
                      >
                        {{ form.errors.situacao }}
                      </div>
                    </div>
                  </div>

                  <hr />
                  <p class="text-uppercase text-sm">Endereço</p>

                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >CEP</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite o CEP"
                          v-model="form.cep"
                          @blur="buscaCep()"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.cep }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.cep }"
                      >
                        {{ form.errors.cep }}
                      </div>
                    </div>

                    <div class="col-md-8">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Rua</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite a rua"
                          v-model="form.rua"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.rua }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.rua }"
                      >
                        {{ form.errors.rua }}
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Número</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite o nº da casa"
                          v-model="form.numero"
                          onfocus="focused(this)"
                          ref="numero"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.numero }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.numero }"
                      >
                        {{ form.errors.numero }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Bairro</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite o bairro"
                          v-model="form.bairro"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.bairro }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.bairro }"
                      >
                        {{ form.errors.bairro }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Cidade</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite a cidade"
                          v-model="form.cidade"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.cidade }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.cidade }"
                      >
                        {{ form.errors.cidade }}
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="form-group">
                        <label
                          for="example-text-input"
                          class="form-control-label"
                          >Estado</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Digite a estado"
                          v-model="form.estado"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.estado }"
                        />
                      </div>
                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.estado }"
                      >
                        {{ form.errors.estado }}
                      </div>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-between">
                    <div class="col-md-4 ">
                      <label
                          for="complemento"
                          class="form-control-label"
                          >Complemento</label
                        >

                      <input
                          class="form-control"
                          type="text"
                          placeholder="Complemento (Opcional)"
                          v-model="form.complemento"
                          onfocus="focused(this)"
                          onfocusout="defocused(this)"
                          :class="{ 'is-invalid': form.errors.complemento }"
                        />
                    </div>

                    <div class="col-md-2">
                    <button

                      class="btn btn-primary mt-4"
                      :disabled="form.processing"
                      @click.prevent="register"
                    >
                      Enviar Cadastro
                    </button>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
  </guest-layout>
</template>

<script>
import GuestLayout from "@/Layouts/GuestLayout";
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
export default {
  props: ["prefeitura", "cnaes"],
  components: {
    GuestLayout,
    JetAuthenticationCardLogo
  },

  data() {
    return {
      cnaesOptions: this.cnaes,
      form: this.$inertia.form({
        id: "",
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        cep: "",
        rua: "",
        numero: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        telefone: "",
        cnpj: "",
        razao_social: "",
        data_abertura: "",
        porte: "",
        situacao: "",
        cnae_id: "",

        prefeitura_url: this.prefeitura.url,
        //role: this.user.role,
      }),
    };
  },

  computed: {
    cnaesOptionConcat() {
      return this.cnaesOptions.map((cnae) => {
        return {
          id: cnae.id,
          descricao: cnae.codigo + " - " + cnae.descricao,
        };
      });
    },
  },

  methods: {
    register() {
      this.form.post(this.route("lojistas.register.store"), {
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
        },
      });
    },

    buscaCep() {
      axios
        .get("https://viacep.com.br/ws/" + this.form.cep + "/json/")
        .then((response) => {
          this.form.rua = response.data.logradouro;
          this.form.bairro = response.data.bairro;
          this.form.cidade = response.data.localidade;
          this.form.estado = response.data.uf;

          //focus no campo numero
          this.$refs.numero.focus();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
</style>
